import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCookie, setCookie } from '../utils/cookies';

const ColorModeContext = createContext();

export const useColorMode = () => {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error('useColorMode must be used within a ColorModeProvider');
  }
  return context;
};

export const ColorModeProvider = ({ children }) => {
  const [colorMode, setColorModeState] = useState(() => {
    // Load color mode from cookie, default to 'dark' if not found
    return getCookie('colorMode') || 'dark';
  });

  const setColorMode = (newColorMode) => {
    setColorModeState(newColorMode);
    setCookie('colorMode', newColorMode);
  };

  // Update document theme when color mode changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', colorMode);
  }, [colorMode]);

  const value = {
    colorMode,
    setColorMode,
  };

  return (
    <ColorModeContext.Provider value={value}>
      {children}
    </ColorModeContext.Provider>
  );
};

export const PALETTE = {
  light: {
    background: 'rgba(100, 190, 255, 0.1)',
    text: '#000000',
  },
  dark: {
    background: 'rgba(0, 0, 0, 0.1)',
    text: '#ffffff',
  },
};

// Define color system: 10 colors with light and dark shades
export const CLASS_COLORS = [
  { light: '#dd2d4a', dark: '#880d1e', contrastText: '#ffffff' }, // Red
  { light: '#00b4d8', dark: '#0077b6', contrastText: '#ffffff' }, // Blue
  { light: '#a6c36f', dark: '#828c51', contrastText: '#ffffff' }, // Green
  { light: '#7b2cbf', dark: '#5a189a', contrastText: '#ffffff' }, // Purple
  { light: '#ffa200', dark: '#ff7b00', contrastText: '#000000' }, // Orange
  { light: '#6fffe9', dark: '#5bc0be', contrastText: '#000000' }, // Cyan
  { light: '#ff758f', dark: '#c9184a', contrastText: '#ffffff' }, // Pink
  { light: '#ffe548', dark: '#ffb20f', contrastText: '#000000' }, // Yellow
];
